<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['no']" :placeholder="$t('placeholder.orderNo')" class="query" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" class="query" @pressEnter="search" @search="search"/>
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="scrollY"
      keep-source
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="submissionAdvice.operator" title="business.label.submissionAdviceOperator"/>
      <vxe-column field="submissionAdvice.content" title="business.label.submissionAdviceContent"/>
      <vxe-column field="approvalAdvice.operator" title="business.label.approvalAdviceOperator"/>
      <vxe-column field="approvalAdvice.content" title="business.label.approvalAdviceContent"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment/moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'DisqualificationDestoryApplyTable',
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'item.no': '',
        'storer.id': undefined,
        'orderStatus': 3,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      },
      storerData: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条
    }
  },
  mounted() {
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storerData = res.result
      }
    })
    this.getData()
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.dateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.dateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    reset() {
      this.query = {
        'no': '',
        'item.no': '',
        'storer.id': undefined,
        'orderStatus': 3,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      }
      this.page = 1
      this.size = 20
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('disqualificationOrderFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick(row) {
      this.$emit('dblclick', row)
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>